/**
 * Capitalizes the first letter of each word in a name.
 * Handles multi-word names like "mary jane" -> "Mary Jane"
 *
 * @param name - The name to capitalize
 * @returns The capitalized name, or empty string if input is falsy
 */
export function capitalizeName(name: string | null | undefined): string {
  if (!name) return '';

  return name
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

/**
 * Formats a full name from first and last name parts.
 * Capitalizes each part properly.
 *
 * @param firstName - First name
 * @param lastName - Last name
 * @returns Formatted full name
 */
export function formatFullName(
  firstName: string | null | undefined,
  lastName: string | null | undefined
): string {
  const parts = [firstName, lastName]
    .filter(Boolean)
    .map(part => capitalizeName(part));

  return parts.join(' ');
}
